import React, { Component, Fragment } from "react";
import { debounce, cloneDeep } from "lodash";
import {
  Avatar,
  Button,
  Col,
  Form,
  InputNumber,
  List,
  Modal,
  Row,
  Select,
  Table,
  Tooltip,
} from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { PriceFormat, SearchFormat } from "../scripts/helpers";
import { Constants } from "../scripts/settings";
import API from "../scripts/api";
import Resources from "../scripts/resources";
import Rules from "../scripts/rules";

class OrderForm extends Component {
  constructor() {
    super();

    this.state = {
      couriers: [],
      data: {
        offerCart: 0,
        payableCart: 0,
        products: [],
        total: 0,
        transferringCost: 0,
      },
      products: [],
      user: { address: [] },
    };

    this.formRef = React.createRef();
    this.boxRef = React.createRef();
    this.inputRef = React.createRef();

    this.handleSearch = debounce(this.handleSearch, 500);
  }

  handleFilter = (input, option) => {
    const value = SearchFormat(input);
    const split = value.split(" ");
    let valid = option.code.indexOf(value) >= 0;

    split.forEach((val) => {
      valid = valid || option.name.indexOf(val) >= 0;
    });

    return valid;
  };

  handleCount = (value, record) => {
    const products = [...this.state.data.products];
    const index = products.findIndex((o) => o.id === record.id);
    const product = products[index];
    product.count = value;
    products.splice(index, 1, product);
    this.setState({ data: { ...this.state.data, ...{ products: products } } });
  };

  handleSelect = (value, clear) => {
    if (value) {
      const { data } = this.state;
      const product = data.products.find((o) => o.id === value);

      if (product) {
        this.handleCount(product.count + 1, product);
      } else {
        const product = this.state.products.find((o) => o.id === value);
        this.setState({
          data: { ...data, ...{ products: [...data.products, product] } },
        });
      }

      if (clear) {
        this.setState({ products: [] });
        this.boxRef.current.resetFields();
        this.inputRef.current.focus();
      }
    } else {
      this.setState({ products: [] });
    }
  };

  handleRemove = (id) => {
    const products = [...this.state.data.products];
    this.setState({
      data: {
        ...this.state.data,
        ...{ products: products.filter((o) => o.id !== id) },
      },
    });
  };

  handleSearch = (value) => {
    if (value) {
      API.product.list({ q: SearchFormat(value) }).then((result) => {
        if (result.data && result.data.length) {
          const products = result.data.map((o) => {
            return {
              id: o.id,
              name: o.name,
              image: o.gallery && o.gallery.length ? o.gallery[0].image : null,
              code: o.code,
              priceOne: parseInt(o.priceOne),
              priceTwo: parseInt(o.priceTwo),
              priceThree: parseInt(o.priceThree),
              offer: parseInt(o.priceOne),
              count: 1,
            };
          });

          this.setState({ products: products });

          if (products.length === 1) {
            setTimeout(() => {
              this.handleSelect(products[0].id, true);
            }, 0);
          }
        } else {
          this.setState({ products: [] });
        }
      });
    }
  };

  handleOffer = (value) => {
    this.setState({ data: { ...this.state.data, ...{ offerCart: value } } });
  };

  handleTransfer = (value) => {
    this.setState({
      data: { ...this.state.data, ...{ transferringCost: value } },
    });
  };

  handleSubmit = () => {
    this.formRef.current.validateFields().then((values) => {
      const cloneData = cloneDeep({ ...this.state.data, ...values });
      const address = this.state.user.address.find(
        (o) => o.id === cloneData.addressId
      );

      cloneData.lat = address.lat;
      cloneData.lng = address.lng;
      cloneData.address = address.address;
      cloneData.products = cloneData.products.map((o) => {
        const price = o.priceOne * o.count;
        // const discount = o.priceTwo ? (o.priceOne - o.priceTwo) * o.count : 0;
        const discount = 0;


        return {
          product_id: o.id,
          count: o.count,
          price: price,
          payable: price - discount,
          offer: discount,
        };
      });

      this.props.onSubmit(cloneData);
    });
  };

  handleWillUnmount = () => {
    this.formRef.current.resetFields();
    this.boxRef.current.resetFields();

    this.setState({
      data: {
        offerCart: 0,
        payableCart: 0,
        products: [],
        total: 0,
        transferringCost: 0,
      },
      products: [],
      user: { address: [] },
    });
  };

  handleDidMount = (data = {}) => {
    const cloneData = {
      id: data.id,
      address: data.address,
      addressId: data.address_id,
      descriptionPostman: data.descriptionPostman,
      descriptionUser: data.descriptionUser,
      lat: data.lat,
      lng: data.lng,
      offerCart: parseInt(data.offer),
      orderType: data.orderType,
      payableCart: 0,
      paymentType: data.paymentType,
      phone: data.user.phone,
      postman_id: data.delivery ? data.delivery.postman_id : undefined,
      postType: data.postType,
      status: data.status,
      total: 0,
      transferringCost: parseInt(data.transferringCost),
    };

    cloneData.products = data.product.map((o) => {
      return {
        id: o.id,
        name: o.name,
        image: o.gallery && o.gallery.length ? o.gallery[0].image : null,
        inventory: o.inventory,
        code: o.code,
        priceOne: o.priceOne,
        priceTwo: o.priceTwo,
        count: o.pivot.count,
        supplier: o.supplier,
      };
    });

    this.formRef.current.setFieldsValue(cloneData);
    this.setState({ data: cloneData, user: data.user });
  };

  componentDidMount() {
    API.user.list({ level: ["postman"] }).then((result) => {
      this.setState({ couriers: result.data || [] });
    });
  }

  render() {
    const { onCancel, submitting, visible } = this.props;
    const { couriers, data, products, user } = this.state;

    const columns = [
      {
        title: Resources.title,
        dataIndex: "name",
      },
      {
        title: Resources.image,
        dataIndex: "image",
        width: "50px",
        render: (val) => (
          <Tooltip
            title={
              <Avatar
                src={`${Constants.imagePathProduct}${val}`}
                shape="square"
                size={200}
              />
            }
          >
            <Avatar
              src={`${Constants.imagePathProduct}${val}`}
              shape="square"
              size="small"
            />
          </Tooltip>
        ),
      },
      {
        title: Resources.supplier,
        dataIndex: "supplier",
        className: "col-centvaler text-danger",
        width: "150px",
        render: (val) => (val ) ? val?.name + " "+ val?.family  + ` (${val.supplier_code})`: ""
      },
      {
        title: Resources.barcode,
        dataIndex: "code",
        className: "col-center",
        width: "150px",
      },
      {
        title: Resources.inventory,
        dataIndex: "inventory",
        className: "col-center",
        width: "90px",
        render: (val) => val || 0,
      },
      {
        title: Resources.count,
        dataIndex: "count",
        className: "col-center",
        width: "100px",
        render: (val, record) => (
          <InputNumber
            min={1}
            value={val}
            onChange={(value) => this.handleCount(value, record)}
            style={{ width: "100%" }}
            size="large"
          />
        ),
      },
      {
        title: `${Resources.price} (${Resources.rial})`,
        dataIndex: "priceOne",
        className: "col-center",
        width: "120px",
        render: (val) => PriceFormat(val),
      },
      {
        title: Resources.discount,
        dataIndex: "priceTwo",
        className: "col-center",
        width: "100px",
        render: (val, record) => 0,
      },
      {
        title: `${Resources.price} (${Resources.rial})`,
        dataIndex: "sum",
        className: "col-center",
        width: "120px",
        render: (val, record) =>
          PriceFormat(
            ( record.priceOne) * record.count
          ),
      },
      {
        title: Resources.action,
        dataIndex: "id",
        className: "col-center",
        width: "80px",
        render: (val) => (
          <Tooltip title={Resources.delete}>
            <Button
              type="link"
              icon={<DeleteOutlined />}
              onClick={() => this.handleRemove(val)}
            />
          </Tooltip>
        ),
      },
    ];

    data.total = 0;

    data.products.forEach((o) => {
      data.total += (parseFloat(o.priceTwo) || parseFloat(o.priceOne)) * parseInt(o.count);
    });

    data.payableCart = data.total;


    return (
      <Fragment>
        <Modal
          title={Resources.edit}
          visible={visible}
          onOk={this.handleSubmit}
          onCancel={onCancel}
          okText={Resources.confirm}
          cancelText={Resources.cancel}
          okButtonProps={{ loading: submitting }}
          cancelButtonProps={{ disabled: submitting }}
          width={1000}
        >
          <Form ref={this.boxRef}>
            <Form.Item name="search">
              <Select
                allowClear
                filterOption={(input, option) =>
                  this.handleFilter(input, option)
                }
                onSearch={this.handleSearch}
                onChange={(val) => this.handleSelect(val, false)}
                placeholder={Resources.search}
                ref={this.inputRef}
                className="ant-select-xl"
                showSearch
              >
                {products.map((o) => (
                  <Select.Option
                    key={o.id}
                    value={o.id}
                    name={o.name}
                    code={o.code}
                  >
                    {o.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Form>
          <Table
            columns={columns}
            dataSource={data.products}
            pagination={false}
            size="small"
            rowKey="id"
            scroll={{ x: 952 }}
          />
          <List
            size="small"
            style={{ backgroundColor: "#fafafa", marginBottom: 8 }}
          >
            <List.Item>
              <List.Item.Meta
                title={`${Resources.sum} ${Resources.factor} (${Resources.rial})`}
                style={{ marginRight: 8 }}
              />
              <span style={{ width: 120, marginLeft: 80, textAlign: "center" }}>
                {PriceFormat(data.total)}
              </span>
            </List.Item>
            <List.Item>
              <List.Item.Meta
                title={`${Resources.transferCost} (${Resources.rial})`}
                style={{ marginRight: 8 }}
              />
              <span style={{ width: 120, marginLeft: 80 }}>
                <InputNumber
                  value={data.transferringCost}
                  min={0}
                  onChange={this.handleTransfer}
                  style={{ width: "100%" }}
                />
              </span>
            </List.Item>
            <List.Item>
              <List.Item.Meta
                title={`${Resources.discount} (${Resources.rial})`}
                style={{ marginRight: 8 }}
              />
              <span style={{ width: 120, marginLeft: 80 }}>
                <InputNumber
                  value={data.offerCart}
                  min={0}
                  max={data.total + data.transferringCost}
                  onChange={this.handleOffer}
                  style={{ width: "100%" }}
                />
              </span>
            </List.Item>
            <List.Item>
              <List.Item.Meta
                title={`${Resources.finalPrice} (${Resources.rial})`}
                style={{ marginRight: 8 }}
              />
              <span style={{ width: 120, marginLeft: 80, textAlign: "center" }}>
                {PriceFormat(data.payableCart)}
              </span>
            </List.Item>
          </List>
          <List size="small" style={{ marginBottom: 8 }}>
            <List.Item>
              <List.Item.Meta
                title={`${Resources.description} ${Resources.user}`}
                style={{ marginRight: 8 }}
              />
              <div
                className="ant-list-item-meta-description"
                style={{ marginLeft: 8 }}
              >
                {data.descriptionUser || "-"}
              </div>
            </List.Item>
            <List.Item>
              <List.Item.Meta
                title={`${Resources.description} ${Resources.carrier}`}
                style={{ marginRight: 8 }}
              />
              <div
                className="ant-list-item-meta-description"
                style={{ marginLeft: 8 }}
              >
                {data.descriptionPostman || "-"}
              </div>
            </List.Item>
          </List>
          <Form
            ref={this.formRef}
            onFinish={this.handleSubmit}
            layout="vertical"
          >
            <Row gutter={24}>
              <Col xs={24}>
                <Form.Item
                  name="addressId"
                  label={Resources.address}
                  rules={Rules.required}
                >
                  <Select placeholder={Resources.choose}>
                    {user.address.map((o) => (
                      <Select.Option
                        key={o.id}
                        value={o.id}
                        lat={o.lat}
                        lng={o.lng}
                      >
                        {o.address}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} md={6}>
                <Form.Item
                  name="paymentType"
                  label={`${Resources.type} ${Resources.payment}`}
                  rules={Rules.required}
                >
                  <Select placeholder={Resources.choose}>
                    <Select.Option value="cardReader">
                      {Resources.pos}
                    </Select.Option>
                    <Select.Option value="cash">{Resources.cash}</Select.Option>
                    <Select.Option value="credit">
                      {Resources.credential}
                    </Select.Option>
                    <Select.Option value="port">{Resources.port}</Select.Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} md={6}>
                <Form.Item
                  name="postType"
                  label={`${Resources.type} ${Resources.submit}`}
                  rules={Rules.required}
                >
                  <Select placeholder={Resources.choose}>
                    <Select.Option value="delivery">
                      {Resources.storeCourier}
                    </Select.Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} md={6}>
                <Form.Item
                  name="postman_id"
                  label={Resources.carrier}
                  rules={Rules.required}
                >
                  <Select placeholder={Resources.choose}>
                    {couriers.map((o) => (
                      <Select.Option key={o.id} value={o.id}>
                        {o.name} {o.family}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} md={6}>
                <Form.Item
                  name="status"
                  label={Resources.status}
                  rules={Rules.required}
                >
                  <Select placeholder={Resources.choose}>
                    <Select.Option value="0">{Resources.suspend}</Select.Option>
                    <Select.Option value="1">{Resources.process}</Select.Option>
                    <Select.Option value="2">{Resources.submit}</Select.Option>
                    <Select.Option value="3">
                      {Resources.delivered}
                    </Select.Option>
                    <Select.Option value="4">
                      {Resources.returned}
                    </Select.Option>
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal>
      </Fragment>
    );
  }
}

export default OrderForm;
